<template>
  <base-panel>
    <template v-if="hasHeader || icon" slot="header">
      <div v-if="hasHeader" class="flex gap-4 items-center justify-between">
        <div class="flex gap-2 text-xs text-secondary-500 dark:text-darkblue-100 font-medium">
          <span v-if="hasHeaderSlot" class="mr-1">
            <slot name="header" />
          </span>
          <span v-if="hasHeaderText" class="header-text">{{header}}</span>
        </div>
        <div v-if="icon" class="icon-wrapper" :class="finalIconClass">
          <base-icon :name="icon"/>
        </div>
      </div>
    </template>
    <template slot="content"> 
      <div class="content-text text-2xl font-bold text-primary-900 dark:text-primary-500">{{content}}</div>
    </template>
    <template v-if="hasFooter" slot="footer">
      <div class="flex items-center gap-1">
        <!-- text-primary-800 dark:text-primary-400 -->
        <div class="flex items-center gap-2 text-xs text-secondary-300 dark:text-darkblue-200">
          <span v-if="hasFooterSlot" class="mr-1">
            <slot name="footer" />
          </span>
          <span v-if="hasFooterText" class="footer-text">{{footer}}</span>
        </div>
      </div>
    </template>
  </base-panel>
</template>

<script>

import iconLibraryNames from '@/components/icons/_iconLibrary.js'
export default {
  name: 'single-panel',
  
  props: {
    content: String,
    icon: {
      type: String,
      validator: function (value) {
        return iconLibraryNames.includes(value)
      }
    },
    iconClass: {
      type: [String, Object, Array],
      default: ''
    },
    header: String,
    footer: String,
    headerStatusColor: String,
    footerStatusColor: String,
  },
  computed: {
    hasHeaderSlot () {
      return !!this.$slots.header || !!this.$scopedSlots.header
    },
    hasHeaderText () {
      return !!this.header
    },
    hasHeader () {
      return this.hasHeaderSlot || this.hasHeaderText
    },
    hasFooterSlot () {
      return !!this.$slots.footer || !!this.$scopedSlots.footer
    },
    hasFooterText () {
      return !!this.footer
    },
    hasFooter () {
      return this.hasFooterSlot || this.hasFooterText
    },
    finalIconClass () {
      const defaultClass = 'bg-primary-100 dark:bg-darkblue-600 text-primary-800'
      return [defaultClass, this.iconClass]
    }
  }
}
</script>

<style scoped>
.icon-wrapper {
  @apply w-8 h-8 rounded-lg flex items-center justify-center;
}
.content-red-500 .content-text, .footer-red-500 .footer-text {
  @apply text-red-500
}
.content-red-700 .content-text, .footer-red-700 .footer-text {
  @apply text-red-700
}
.content-yellow-500 .content-text, .footer-yellow-500 .footer-text {
  @apply text-yellow-500
}
.content-white .content-text {
  @apply text-white
}

.content-blue-custom .content-text, .footer-blue-custom .footer-text {
  @apply text-[#8AC0FF]
}

.content-red-custom .content-text, .footer-red-custom .footer-text {
  @apply text-[#FF7C75]
}

.content-yellow-custom .content-text, .footer-yellow-custom .footer-text {
  @apply text-[#FFDA9E]
}

.header-secondary-200 .header-text {
  @apply text-secondary-200
}
.footer-secondary-400 .footer-text {
  @apply text-secondary-100
}
</style>
